import { Component, h, Host, Prop } from '@stencil/core';
import { Facet } from '~model/facet';
import { translate } from '~service/translation-service';

@Component({
  tag: 'uvex-facet-options',
})
export class FacetOptions {
  @Prop() resultCount: number = 0;
  @Prop() facets!: Facet[];

  private closeFacetOptions() {
    document.body.classList.remove('facet-options-active');
  }

  render() {
    if (!this.facets) {
      return <h3 class="facet-title">{translate('sw.listing.filter.title')}</h3>;
    }
    const options = this.facets.map((facet: Facet) => <uvex-facet-option-list facet={facet} />);

    return (
      <Host class="facet-options">
        <h3 class="facet-title">{translate('sw.listing.filter.title')}</h3>
        <button class="facet-close btn btn-block icon-right" type="button" onClick={_ => this.closeFacetOptions()}>
          {translate('sw.listing.filter.title')}
          <svg width="14" height="14">
            <use href="#fa-close"></use>
          </svg>
        </button>
        <uvex-product-list-active-facets facets={this.facets} resultCount={this.resultCount} />
        {...options}
      </Host>
    );
  }
}
